/**
 * vue-routerConfig 实例配置
 *
 * 配置路由切换钩子
 * - 更改路由标题
 *
 * @since 1.0.0
 * @version 1.0.0
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import routes from '@/routes/index'
import pageTitle from 'utils/page-title'
import store from '@/store'

Vue.use(VueRouter)
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
const routerConfig = (global.$router = new VueRouter({
  mode: 'hash',
  base: process.APP.BASE_PATH,
  routes,

  // scrollBehavior(to, from, savedPosition) {
  //   return {
  //     x: 0,
  //     y: 0
  //   }
  // },
}))

/**
 * 消除nprocess进度条
 */
routerConfig.beforeEach((to, from, next) => {
  // console.log(to)
  let listBreadcrumb = to.matched
  if (listBreadcrumb.length === 3) {
    store.commit('setListBreadcrumb', [
      {
        path: listBreadcrumb[listBreadcrumb.length - 2].path,
        title: listBreadcrumb[listBreadcrumb.length - 2].meta.title,
      },
      {
        path: listBreadcrumb[listBreadcrumb.length - 1].path,
        title: listBreadcrumb[listBreadcrumb.length - 1].meta.title,
      },
    ])
  } else if (listBreadcrumb.length === 2) {
    store.commit('setListBreadcrumb', [
      {
        path: listBreadcrumb[listBreadcrumb.length - 1].path,
        title: listBreadcrumb[listBreadcrumb.length - 1].meta.title,
      },
    ])
  } else if (listBreadcrumb.length === 4) {
    store.commit('setListBreadcrumb', [
      {
        path: listBreadcrumb[listBreadcrumb.length - 3].path,
        title: listBreadcrumb[listBreadcrumb.length - 3].meta.title, // 传入当前路由对象
      },
      {
        path: listBreadcrumb[listBreadcrumb.length - 2].path,
        title: listBreadcrumb[listBreadcrumb.length - 2].meta.title,
      },
      {
        path: listBreadcrumb[listBreadcrumb.length - 1].path,
        title: listBreadcrumb[listBreadcrumb.length - 1].meta.title,
      },
    ])
  }

  if (to.path === '/login') {
    store.commit('setListBreadcrumb', [])
  }

  NProgress.done()
  next()
})

// /**
//  * 设置当前页的分享内容
//  */
// routerConfig.beforeEach((to, from, next) => {
//   // 存在自定义标题时，进行标题重设
//   if (to.meta.shareInfo) {
//     window.showShare = function showShare() {
//       return JSON.stringify(to.meta.shareInfo)
//     }
//   }
//
//   next()
// })

// 设置当前页面的标题
routerConfig.afterEach((to) => {
  // 存在自定义标题时，进行标题重设
  if (to.meta.title) {
    pageTitle(to.meta.title)
  }
})

export default routerConfig
